import { api } from "@/api";
import { useMutation } from "@tanstack/react-query";
import { notify } from "@/shared/notification";

export interface EstablecimientoRequest {
    punto: string;
    email: string;
    telefono: string;
    direccion: string;
    numCasa: number;
    ciudadCodigo: string;
    departamentoCodigo: string;
}

export interface EmisorUpdateRequest {
    nombre: string;
    tipoContribuyente: number;
    numDocumento: string;
    digitoVerificador: number;
    actividadComercialId: string;
    tipoTransaccion: number;
    tipoImpuestoAfectado: number;
    timbrado: string;
    fechaInicioTimbrado: string;
    cSC1: string;
    pathCertificado: string;
    passwordCertificado: string;
    logo?: File | null;
    establecimientos: EstablecimientoRequest[];
}

export async function updateEmisor(id: string, request: EmisorUpdateRequest) {
    const response = await api.putForm(`emisor/${id}`, request);
    return response.data;
}

export function useUpdateEmisorMutation() {
    return useMutation({
        mutationFn: ({ id, data }: { id: string; data: EmisorUpdateRequest }) =>
            updateEmisor(id, data),
        onSuccess: () => {
            notify("Datos del emisor actualizados correctamente");
        }
    });
}
